<template>
    <v-card>
        <v-card-title>
            訊息發送
        </v-card-title>
        <v-container fluid>
            <v-text-field
                v-model="requestItem.phone"
                label="電話號碼"
                required
            >
            </v-text-field>
            <v-textarea
                v-model="requestItem.message"
                counter = 1000
                label="簡訊內容"
                required
            >
            </v-textarea>
            <v-btn small @click="sendMessage">
                <div v-show="!sendLoading">傳送訊息</div>
                <div v-show="sendLoading">
                    <v-progress-circular size="25" indeterminate></v-progress-circular>
                </div>
            </v-btn>
            <v-btn small @click="closeDialog">關閉
            </v-btn>
            <p class="mt-3">{{ message }}</p>

        </v-container>
    </v-card>
</template>
<script>
import SMSService from '../../services/SMSService'
export default {
    props:{
        sendLoading: Boolean
    },
    data(){
        return {
            requestItem :{
                phone:'0935204196',
                message:'這是測試簡訊的第一行\r\n這是測試簡訊的第二行\r\n這是測試簡訊的第三行\r\n這是測試簡訊的第四行\r\n這是測試簡訊的第五行\r\n這是測試簡訊的第六行\r\n這是測試簡訊的第七行\r\n這是測試簡訊的第八行\r\n這是測試簡訊的第九行\r\n這是測試簡訊的第十行\r\n這是測試簡訊的第十一行\r\n這是測試簡訊的第十二行\r\n這是測試簡訊的第十三行\r\n這是測試簡訊的第十四行\r\n這是測試簡訊的第十五行\r\n這是測試簡訊的第十六行\r\n這是測試簡訊的第十七行\r\n這是測試簡訊的第十八行\r\n這是測試簡訊的第十九行\r\n這是測試簡訊的第二十行'
            },
            message:''
        }
    },
    methods:{
        sendMessage(){
            
            //this.sendLoading = true
            SMSService.sendSingleMessage(this.requestItem).then((response) =>{
                if (response.result === true){
                    //this.sendLoading = false
                    this.message = response.message
                }
            })
            .catch((e) =>{
                console.log(e);
                this.message = 'Error'
            })
        },
        closeDialog(){
            //父元件須要去指定@ChangeDialogShowSettingEvent所設定的方法，該方法必須要指定參數。
            //此事件用來觸發Dialog關閉
            this.$emit('ChangeDialogShowSettingEvent', false)
        }
    }
}
</script>
